import React from 'react';
import {
  MainButton,
  StyledModal,
  StyledModalHeader,
  SubmitButton,
} from '../../../../../common/form/FormElements';
import Form from '../../../../../antd/form/Form/Form';
import { Form as AntdForm, Grid, Alert } from 'antd';
import FormFileUpload from '../../../../../antd/form/FormFileUpload/FormFileUpload';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ErrorMessages from './ErrorMessages';
import { required } from '../../../../../antd/form/FormValidation';

const ReservationsImport = ({ toggle, onSubmit, validationErrors }) => {
  const { t } = useTranslation();
  const [form] = AntdForm.useForm();
  const screens = Grid.useBreakpoint();

  // Warning alert visibility - show after file is selected or dropped (value changes)
  const [showWarning, setShowWarning] = React.useState(false);
  // Locally hide backend error messages when user picks a new file
  const [hideErrors, setHideErrors] = React.useState(false);

  // Watch the 'file' form field; when it becomes truthy, show the warning and hide errors
  const watchedFile = AntdForm.useWatch('file', form);
  React.useEffect(() => {
    if (watchedFile) {
      setShowWarning(true);
      setHideErrors(true);
    }
  }, [watchedFile]);

  // When backend returns validation errors (flat array), hide the warning and allow showing errors again
  React.useEffect(() => {
    if (Array.isArray(validationErrors) && validationErrors.length > 0) {
      setShowWarning(false);
      setHideErrors(false);
    }
  }, [validationErrors]);

  const initials = { file: undefined };

  return (
    <StyledModal
      open
      onCancel={() => toggle()}
      footer={null}
      width={screens.md ? '60%' : '100%'}
    >
      <StyledModalHeader>
        {t('Import súboru s rezerváciami miestností')}
      </StyledModalHeader>
      <Form onFinish={onSubmit} initialValues={initials} form={form}>
        {() => (
          <div style={{ padding: '10px' }}>
            <h4>{t('Formát importovaného súboru:')}</h4>
            <ul>
              <li>
                {t('Pri ukladaní súboru v MS Excel je potrebné vybrať typ:')}{' '}
                <strong>{t('CSV UTF-8 (oddelené čiarkami)')}</strong>
              </li>
              <li>
                {t('Zoznam stĺpcov:')}{' '}
                <strong>
                  {t(
                    'Dátum od, Čas od, Dátum do, Čas do, Miestnosť, Dôvod rezervácie',
                  )}
                </strong>
              </li>
              <li>{t('Všetky stĺpce sú povinné')}</li>
              <li>{t('Každý riadok musí mať práve 6 stĺpcov')}</li>
              <li>
                {t(
                  'Oddeľovač stĺpcov je bodkočiarka, oddeľovač riadkov je nový riadok',
                )}
              </li>
              <li>{t('Importovaný súbor nesmie mať záhlavie')}</li>
              <li>{t('Rezervácie s opakovaním nie sú podporované')}</li>
              <li>
                {t(
                  'Ak potrebujete importovať celodennú rezerváciu, čas od nastavte na 0:00 a čas do na 23:59',
                )}
              </li>
              <li>
                {t('Pri importe sa nekontrolujú kolízie v rámci predmetov')}
              </li>
              <li>
                {t(
                  'Ak a nachádza v texte dôvodu bodkočiarka, text musíte uzatvoriť do úvodzoviek',
                )}
              </li>
            </ul>
            <h4 style={{ marginTop: '20px' }}>
              {t('Príklad jedného riadku v importovanom súbore:')}
            </h4>
            <p>
              <em>
                21.1.2025;8:00;21.1.2025;12:00;RA012;Skúška z informatiky 1
              </em>
            </p>
            <FormFileUpload
              label={t('Vybrať súbor')}
              name={'file'}
              rules={[required(t)]}
            />

            {showWarning && (
              <Alert
                type="warning"
                showIcon
                title={t(
                  'V prípade, že sa v importovanom súbore nachádzajú chyby, rezervácie nebudú uložené.',
                )}
              />
            )}

            {!hideErrors && (
              <div style={{ marginBottom: 16 }}>
                <ErrorMessages errors={validationErrors} />
              </div>
            )}

            <FormButtonsContainer>
              <MainButton onClick={() => toggle()}>{t('Zrušiť')}</MainButton>
              <SubmitButton
                submitKey={'file'}
                onClick={() => setShowWarning(true)}
              >
                {t('Nahrať')}
              </SubmitButton>
            </FormButtonsContainer>
          </div>
        )}
      </Form>
    </StyledModal>
  );
};

ReservationsImport.propTypes = {
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
  validationErrors: PropTypes.any,
};

export default ReservationsImport;
